<template>
  <div class="inner-box">
    <div slot="content">
      <el-form size="medium" @submit.prevent="save">
        <div class="content-name">
          <h2 class="dp-ib">{{ routeName }}</h2>
          <el-form-item label-width="0px" style="float: right;">
            <el-button type="primary" icon="el-icon-search" @click="goOpen">
              {{ this.$i18n.messages[this.$store.state.locale].search }}
            </el-button>
          </el-form-item>
        </div>
      </el-form>

      <div class="search-form">
        <el-form size="mini">
          <el-row style="margin-bottom: 0px;">
            <el-col :span="6">
              <el-form-item label="센터구분" label-width="100px">
                <el-select v-model="form.asAgentType">
                  <el-option value='' label="전체">전체</el-option>
                  <el-option
                      v-for="item in combos['asAgentType']"
                      :key="item.value"
                      :value="item.key"
                      :label="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="지역" label-width="100px">
                <el-select v-model="form.catIdArea">
                  <el-option value='' label="전체">전체</el-option>
                  <el-option
                      v-for="item in combos['catIdArea']"
                      :key="item.value"
                      :value="item.key"
                      :label="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="센터명" label-width="100px">
                <el-input type="text" v-model="form.asAgentNm" @keyup.native.enter="goOpen"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="계약상태" label-width="100px">
                <el-select v-model="form.contractStatus2">
                  <el-option value='' label="선택">선택</el-option>
                  <el-option
                      v-for="item in combos['contractStatus2']"
                      :key="item.value"
                      :value="item.key"
                      :label="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <el-form-item label="대표자명" label-width="100px">
                <el-input type="text" v-model="form.keyManNm"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="상호명" label-width="100px">
                <el-input type="text" v-model="form.asAgentFullNm"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="기사명" label-width="100px">
                <el-input type="text" v-model="form.userNm"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="기사ID" label-width="100px">
                <el-input type="text" v-model="form.userCd"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>

    <div class="inner-box">
      <div class="table-area">
        <div class="table-b">
          <div class="table-header">
            <div class="grid-tbl-box">
              <ag-grid-vue
                  ref="grid"
                  :style="gridStyle"
                  class="ag-theme-alpine"
                  row-selection="single"
                  :column-defs="columnDefs"
                  :grid-options="mainGridOptions"
                  :row-data="data"
                  :default-col-def="defaultColDef"
                  :framework-components="frameworkComponent"
                  :statusBar="statusBar"
                  @grid-ready="onReadyMain"
                  @cell-clicked="onCellClicked" />
            </div>
          </div>
        </div>
      </div>
 
    </div>
  </div>
</template>

<script>
import DatepickerCellRenderer from "@/components/agGrid/datepicker-cell-renderer";
import MaskEditCellRenderer from "@/components/agGrid/maskedit-cell-renderer";
import SelectCellRenderer from "@/components/agGrid/select-cell-renderer";
import CheckboxCellRenderer from "@/components/agGrid/checkbox-cell-renderer";
import RadioCellRenderer from "@/components/agGrid/radio-cell-renderer";
import NumberInputCellRender from "@/components/agGrid/numberinput-cell-renderer";
import InputCellRender from "@/components/agGrid/input-cell-renderer";
import ButtonCellRenderer from "@/components/agGrid/button-cell-renderer";

function _url(...args) {
  args = args.map(x =>
      String(x || "")
          .trim()
          .replace(/^\/*|\/*$/g, "")
  );
  return args.filter(x => x).join("/");
}

function _phone(hp){
    return hp ? hp.replace(/[^0-9]/g, "").replace(/(^02|^0505|^1[0-9]{3}|^0[0-9]{2})([0-9]+)?([0-9]{4})$/, "$1-$2-$3" ) : ''
}

export default {
  props: {
  },
  data() {
    return {
      data: [],
      form: {
        companyId : '',
        asAgentType : '',         // 센터구분
        asAgentNm : '',           // 센터명
        catIdArea : '',           // 지역
        asAgentFullNm : '',           // 센터명
        keyManNm : '',
        userNm : '' ,
        userCd : '' ,
        contractStatus2 : ''      // 계약상태
      },
      combos: {
        'asAgentType' : [],
        'catIdArea' : [],
        'contractStatus2' : []
      },
      startDt: this.$moment().add(-7, 'days').format('YYYY-MM-DD'),
      endDt: this.$moment().format('YYYY-MM-DD'),
      accountPrint: [],         // 세금계산서 발행
      showDeliverySave: false, 
      showDeliveryCancel: false,
      showPrintAccount: false,
      curDelivery: '',          // 현재 선택된 ORDER의 배송확정여부

      // AG-GRID OPTION [START]
      gridStyle : 'padding-top: 40px; width: 100%;height: 300px; min-height:100px;',
      defaultColDef: {
          resizable: true
        , filter:false
        , sortable: true
      },
      mainGridApi: null,
      mainColumnApi: null,
      mainGridOptions: {
        enableColResize: true,
        enableFilter: true,
        animateRows: false,
        enableSorting: true,
      },
      columnDefs: [],
      frameworkComponent : {
        datePicker: DatepickerCellRenderer,
        maskEdit: MaskEditCellRenderer,
        select: SelectCellRenderer,
        checkBox: CheckboxCellRenderer,
        radio: RadioCellRenderer,
        numberInput: NumberInputCellRender,
        input: InputCellRender,
        button: ButtonCellRenderer
      },
      statusBar: null,
    }
  },
  methods: {
    onReadyMain() {
      this.mainGridApi = this.mainGridOptions.api;
      this.mainColumnApi = this.mainGridOptions.columnApi;

      this.init();
    },
    onReadySub() {
      this.subGridApi = this.subGridOptions.api;
      this.subColumnApi = this.subGridOptions.columnApi;
    },
    createMainColumnDefs() {
      this.columnDefs = [
        {headerName:'센터ID', field:'asAgentCd', width:120, cellStyle:{textAlign: 'center'}},
        {headerName:'센터ID', field:'asAgentId', width:120, cellStyle:{textAlign: 'center'}, hide: true},
        {headerName:'센터구분', field:'asAgentTypeNm', width:150, cellStyle:{textAlign: 'center'}},
        {headerName:'센터구분', field:'asAgentType', width:150, cellStyle:{textAlign: 'center'}, hide: true},
        {headerName:'센터명', field:'asAgentNm', width:210, cellStyle:{textAlign: 'center'}},
        {headerName:'사업장명', field:'asAgentFullNm',  width:220, cellStyle:{textAlign: 'left'}},
        {headerName:'대표자명', field:'keyManNm', width:150, cellStyle:{textAlign: 'center'}},
        {headerName:'주소', field:'addr', width:350, cellStyle:{textAlign: 'left'}},
        {headerName:'업종/업태', field:'businessType', width:120, cellStyle:{textAlign: 'center'}},
        {headerName:'타사운영현황', field:'description', width:250, cellStyle:{textAlign: 'center'}}
      ];
    },
    onCellClicked(params) {
      //const idx = params.rowIndex;
      const field = params.colDef.field;
      this.goDetail(params.data)
    },
    $dismiss() {
      this.$emit('dismiss')
      this.$parent.close()
    },
    isAuth(){
      const auth = this.$store.state.loginInfo.authorities.filter(x=>x.programId===249)
      let GrantSelect = false // 조회권한
      if(auth && auth.length > 0){
        GrantSelect = auth[0].grantSelect === 'Y' ? true : false   
      }

      if(!GrantSelect){
        this.$swal({ type: 'warning', text: '조회권한이 없습니다.' });
        return false;
      }

      return true;
    },
    goOpen() {
      let vm = this
      console.log('goOpen passed ')
      
      if(!this.isAuth()){
        return false;
      }

      const vCatObj = this.combos['catIdArea'].filter(x=>x.key===this.form.catIdArea);
      console.log('search ddss: ', this.form.catIdArea, this.combos['catIdArea'])
      let vCatId = '0';
      if(vCatObj && vCatObj.length>0){
        vCatId = vCatObj[0].key;
      }

      const vContractStatusObj = this.combos['contractStatus2'].filter(x=>x.key===this.form.contractStatus2);
      let vContractStatus = '';
      if(vContractStatusObj && vContractStatusObj.length>0){
        vContractStatus = vContractStatusObj[0].key;
      }

      this.$store.commit('loading')

      const vform = {
        companyId: this.$store.state.loginInfo.compCd || '',
        asAgentType: this.form.asAgentType || '',
        asAgentNm: this.form.asAgentNm || '',
        asAgentFullNm : this.form.asAgentFullNm || '',
        keyManNm : this.form.keyManNm || '',
        userNm : this.form.userNm || '',
        userCd : this.form.userCd || '',
        catId: vCatId || '0', 
        contractStatus: vContractStatus || '',
        sortType: '',
        page: 1,  
        totalPage: 9999,
        totalCount: 9999,
        curPage: 0,
        processTime : ''
      };
console.log('search ============aaa: ', vform)
      this.form.deliveryNoCount = 0; //초기화
      this.$http.post(_url("/api/asAgentMng/list"), vform).then(response => {
        console.log('response.data' , response.data)
        this.data = response.data.map(x=>{
          x.addr = x.addr1 + ' ' + x.addr2;
          const vAsAgentTypeObj = this.combos['asAgentType'].filter(y=>y.key===x.asAgentType);
          if(vAsAgentTypeObj && vAsAgentTypeObj.length>0){
            x.asAgentTypeNm = vAsAgentTypeObj[0].value;
          }
          
          return x;
        }); 

      }).finally(() => {
        this.$store.commit('finish')
      });
    },
    async goDetail(param) {
      // 주문상세내역 조회
      let vm = this
     console.log('gpDetail : ', param) 
      if(!this.isAuth()){
        return false;
      }
      
      this.$store.commit('loading');

      const vform = {
        companyId: this.$store.state.loginInfo.compCd || '',
        asAgentId : param.asAgentId,
        userId : 0,
        useYn : '',
        processTime : '',
        sortType : ''
      };

      console.log('detail vform: ', vform)

      let vSearchData = {
        tab1AsAgentSelItem : {},
        tab2ServiceEngineerSelAgent : [],
        tab3AsAgentSelItem : []
      };
      await this.$http.post(_url("/api/asAgentMng/detail/default"), vform).then(response => {
        console.log('subData data1 : ' , response.data);

        if(response.data && response.data.length>0){
          response.data.map(x=>{
            console.log('x====');
              x.contractStartDt = x.contractStartDt && x.contractStartDt.length>=10? x.contractStartDt.substring(0,10) : '';
              x.contractEndDt = x.contractEndDt && x.contractEndDt.length>=10? x.contractEndDt.substring(0,10) : '';
              return x;

            });

          vSearchData.tab1AsAgentSelItem = response.data[0];
          
        } else {
          vSearchData.tab1AsAgentSelItem = {};
        }
        
        let vResList = [];
        response.data.map(x=>{
          const vmap = {
            ...x,
            ampmTxt : '오전',
            monYn : (x.monMorningYn === 'Y') ? 'O' : 'X',
            tueYn : (x.tueMorningYn === 'Y') ? 'O' : 'X',
            wedYn : (x.wedMorningYn === 'Y') ? 'O' : 'X',
            thuYn : (x.thuMorningYn === 'Y') ? 'O' : 'X',
            friYn : (x.friMorningYn === 'Y') ? 'O' : 'X',
            satYn : (x.satMorningYn === 'Y') ? 'O' : 'X',
            sunYn : (x.sunMorningYn === 'Y') ? 'O' : 'X'
          };
          vResList.push(vmap);

          const vmap2 = {
            ...x,
            ampmTxt : '오후',
            monYn : (x.monAfterNoonYn === 'Y') ? 'O' : 'X',
            tueYn : (x.tueAfterNoonYn === 'Y') ? 'O' : 'X',
            wedYn : (x.wedAfterNoonYn === 'Y') ? 'O' : 'X',
            thuYn : (x.thuAfterNoonYn === 'Y') ? 'O' : 'X',
            friYn : (x.friAfterNoonYn === 'Y') ? 'O' : 'X',
            satYn : (x.satAfterNoonYn === 'Y') ? 'O' : 'X',
            sunYn : (x.sunAfterNoonYn === 'Y') ? 'O' : 'X'
          };
          vResList.push(vmap2);

          return x;
        });
        
        vSearchData.tab3AsAgentSelItem = vResList || [];
        
        
      }).finally(() => {
        this.$store.commit('finish')
      });
      
      await this.$http.post(_url("/api/asAgentMng/detail/agent"), vform).then(response => {
        vSearchData.tab2ServiceEngineerSelAgent = response.data
          .map(x=>{
            x.enterDt = x.enterDt && x.enterDt.length>=10? x.enterDt.substring(0,10) : '';
              
            return x;
          }) || [];
      }).finally(() => {
        this.$store.commit('finish')
      });

      vm.$parent.searchContentInTab(vSearchData) // 현재소스(search) => view(부모) => (다른 자식Tab)
      
    },
    save() {
      console.log('test',this.$parent.$refs.step.next())
    },
    async init() {
      this.$store.commit('loading');
      
      // 센터구분
      this.$http.get(`/api/codeMng/combo`, {params: {parentId: 327}})
        .then(response => {
            this.combos['asAgentType'] = response.data || [];
        })
        .finally(() => {
            //this.form.asAgentType = 'Default'; /** 디폴트 일반선택 */
        });

      // 지역 
      this.$http.get(`/api/codeMng/combo/catId`, {params: {parentId: 217}})
        .then(response => {
            this.combos['catIdArea'] = response.data || [];
        })
        .finally(() => {
            //this.form.catIdArea = 'Default'; /** 디폴트 일반선택 */
        });
    
      // 계약상태  
      this.$http.get(`/api/codeMng/combo`, {params: {parentId: 27860}})
        .then(response => {
            this.combos['contractStatus2'] = response.data || [];
        })
        .finally(() => {
            //this.form.contractStatus2 = 'Default'; /** 디폴트 일반선택 */
        });

      this.createMainColumnDefs();
      
      this.$store.commit('finish')

    },
  },
  created() {
    this.statusBar = {
      statusPanels: [
        { statusPanel: 'agTotalRowCountComponent', align: 'right' },
      ],
    };
  },
  mounted() {
   
  },
  computed: {
    routeName() {
      return this.$route.name
    }
  }
}
</script>


<style lang="scss" scoped>
.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
</style>